import { useLayoutEffect, useState } from 'react';
import { IframeComponents } from 'shared/enums';
import { useLocation } from 'react-router-dom';

export const useOnlineVisit = () => {
  const [isOnlineVisit, setIsOnlineVisit] = useState(true);
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    setIsOnlineVisit(
      window.location.href.includes('onlineVisit') ||
        window.location.href.includes('startVisit') ||
        window.location.href.includes(
          `iframe/${IframeComponents.Questionnaire}`
        ) ||
        window.location.href.includes(`iframe/${IframeComponents.Visit}`)
    );
  }, [pathname]);

  return isOnlineVisit;
};
